const getSessionData = (key) => {
    const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));

    if (sessionData !== null) {
        return sessionData[key] ?? null;
    }

    return null;
};

const setSessionData = (key, value) => {
    const sessionData = JSON.parse(sessionStorage.getItem('sessionData')) ?? {};
    sessionData[key] = value;

    sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
};

export const removeSessionData = () => sessionStorage.removeItem('sessionData');

// Scan QR Code
export const getAccountBookId = () => getSessionData('accountBookId');
export const setAccountBookId = (id) => setSessionData('accountBookId', id);
export const getQRCode = () => getSessionData('qrCode');
export const setQRCode = (qrCode) => setSessionData('qrCode', qrCode);
export const getTableNo = () => getSessionData('tableNo');
export const setTableNo = (tableNo) => setSessionData('tableNo', tableNo);
export const getIsQRCodeStatic = () => getSessionData('isQRCodeStatic');
export const setIsQRCodeStatic = (isQRCodeStatic) => setSessionData('isQRCodeStatic', isQRCodeStatic);
export const getServiceType = () => getSessionData('serviceType');
export const setServiceType = (serviceType) => setSessionData('serviceType', serviceType);
export const getIsPreview = () => getSessionData('isPreview');
export const setIsPreview = (isPreview) => setSessionData('isPreview', isPreview);

// Start Order
export const getTableSessionId = () => getSessionData('tableSessionId');
export const setTableSessionId = (id) => setSessionData('tableSessionId', id);
export const getShareCart = () => getSessionData('shareCart');
export const setShareCart = (shareCart) => setSessionData('shareCart', shareCart);
export const getUseEPayment = () => getSessionData('useEPayment');
export const setUseEPayment = (useEPayment) => setSessionData('useEPayment', useEPayment);

// Home Page
export const getIsLandingPageShown = () => getSessionData('isLandingPageShown');
export const setIsLandingPageShown = () => setSessionData('isLandingPageShown', true);
